import { IBillingUsage } from "../../models";
import * as types from "../constants";

export function addUsage(usage: IBillingUsage) {
  return {
    type: types.ADD_USAGE,
    payload: usage,
  };
}
